// All keys and security staff are saved here.
// !!!!!!! Never upload onto Git with Keys.

export const __GAPI_KEY__ = "AIzaSyDn0hOAdoUrO-FaWJe16Im6FyK9AFs5Cgs"



// WEBPACK FOOTER //
// ./master/jsx/components/Common/keys.js